module.exports = __webpack_public_path__ + "static/flags/VQ-94b5ea90785a3414cd9ee770a58b541e.gif";